import { render, staticRenderFns } from "./nosotros.vue?vue&type=template&id=34d8a564&"
import script from "./nosotros.vue?vue&type=script&lang=js&"
export * from "./nosotros.vue?vue&type=script&lang=js&"
import style0 from "./nosotros.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports